const STORAGE_KEY = 'aiCarSearchVehicleContext';

class CarPageAiBanner {
  /** @type {Element} */
  #banner;
  /** @type {Element|null} */
  #descriptionEl;
  /** @type {Element|null} */
  #labelEl;

  /**
   * @param {Element} banner - The .ai-car-search__vehicle-banner element
   */
  constructor(banner) {
    this.#banner = banner;
    this.#descriptionEl = banner.querySelector('.js-car-page-ai-description');
    this.#labelEl = banner.querySelector('.js-car-page-ai-label');
    this.#init();
  }

  #init() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    let context;
    try {
      context = JSON.parse(raw);
    } catch {
      return;
    }

    const { description, label } = context;
    if (!description && !label) return;

    if (this.#descriptionEl && description) {
      this.#descriptionEl.textContent = description;
    }

    if (this.#labelEl && label) {
      this.#labelEl.textContent = label;
    }

    this.#banner.classList.add('is-visible');
  }

  /**
   * @returns {CarPageAiBanner[]}
   */
  static init() {
    return Array.from(document.querySelectorAll('.ai-car-search__vehicle-banner'))
      .map((banner) => new CarPageAiBanner(banner));
  }
}

export default CarPageAiBanner;
